const beginner = 'beginner';
const medium = 'medium';
const advanced = 'advanced';
const circleOn = 'circle-on';

const Skill = (slug) => {
    const isFirstOn = slug === beginner || slug === medium || slug === advanced;
    const isSecondOn = slug === advanced || slug === medium;

    return `
<div class="tutor-level-circles-container">
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle class="${isFirstOn ? circleOn : ''}" cx="6" cy="6" r="6" fill="black" fill-opacity="0.12"></circle>
    </svg>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle class="${isSecondOn ? circleOn : ''}" cx="6" cy="6" r="6" fill="black" fill-opacity="0.12"></circle>
    </svg>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle class="${slug === advanced ? circleOn : ''}" cx="6" cy="6" r="6" fill="black" fill-opacity="0.12"></circle>
    </svg>
</div>`;
}

export default Skill;